import {common_utils} from "../common/common_utils";
import {slots_utils} from "../../../untils/slots_utils";
import {game_100} from "./game_100";
import {game_101} from "./game_101";
import {game_102} from "./game_102";
import {slots_tool} from "./slots_tool";
import {game_5000} from "./game_5000";
import {game_5001} from "./game_5001";
import {game_5002} from "./game_5002";
import {game_5003} from "./game_5003";
function game_5000_to_5003()
{

}

game_5000_to_5003.readDataValue = function(this1,data)
{
    this1.hasfree = true
    if(this1.hasfree) {
      this1.isfree = common_utils.isFreeTip(data)
    }

    this1.hasbonuswin = false
    this1.mapList = []

    let mul_array = null;
    let winValueList = [];
    let index_mul = 0;
    let winIndex = 0;
    // this1.detailBet = data.detail.bet;

    let odd_map = null;
    if(data.gameId === 5000)
    {
      odd_map = game_5000.odd_map;
    }
    else if(data.gameId === 5001)
    {
      odd_map = game_5001.odd_map;
    }
    else if(data.gameId === 5002)
    {
      odd_map = game_5002.odd_map;
      mul_array =game_5002.mul_array;
    }
    else if(data.gameId === 5003)
    {
      odd_map = game_5003.odd_map;
      mul_array = game_5003.mul_array;
    }
    var rows = 3
    if (data.gameId == 5002) {
      rows = 4
    }
    if (data.gameId == 5003) {
      this1.hasfree = true
      rows = 4
    }

    for (var i = 0; i < rows; i++) {
      for (var j = 0; j < 5; j++) {
        this1.mapList.push(data.detail.map[j * rows + i])
      }
    }
    // 匹配下标
    let s = new slots_utils();
    this1.geValue = s.showSlotsWinLine(data.gameId, this1.mapList, 0, rows).m_dict
    this1.winlines = {};
    this1.winlines["0"] = s.showSlotsWinLineInfo(data.gameId, this1.mapList, 0, rows);
    // console.log(this1.geValue, "geValue")
    this1.mapIndex = []
    this1.mapListDetail = []
    common_utils.readDataValue(this1,data);
    if (Object.keys(this1.geValue).length != 0)
    {
      for (var i = 0; i < Object.keys(this1.geValue).length; i++)
      {
        var mapIndexTmp = Object.values(this1.geValue)[i].flat(Infinity)

        for (var j = 0; j < mapIndexTmp.length; j++) {
          this1.mapIndex.push(mapIndexTmp[j])
          //console.log(this1.mapIndex, "this1.mapIndex")
        }

        var detail = {}
        var lines = 1;
        var mapIndexFullTmp = Object.values(this1.geValue)[i]
        for (var j = 0; j < mapIndexFullTmp.length; j++)
        {
          lines = lines * mapIndexFullTmp[j].length
        }

        detail.key = Object.keys(this1.geValue)[i]
        detail.lines = lines
        detail.length = Object.values(this1.geValue)[i].length

        if (odd_map !=null)
        {
            let mul_value = slots_tool.read_index_mul(mul_array,winIndex,data.isFree);
            detail = slots_tool.winInfo(odd_map,detail,mul_value);
        }
        winValueList.push(detail.winValue);
        this1.mapListDetail.push(detail)
        // console.log("this1.mapListDetail", this1.mapListDetail)
      }
      winIndex++;
    }

    this1.subMapList = []
    this1.subMapIndex = []
    this1.subMapListDetail = []
    if (data.detail.allRestocks && data.detail.allRestocks.length > 1)
    {
      for (var index = 0; index < data.detail.allRestocks.length - 1; index++)
      {
        var subMap = []
        var subIndex = []
        if (index == 0) {
          subMap = this1.mapList
          subIndex = this1.mapIndex
        } else {
          subMap = this1.subMapList[index - 1]
          subIndex = this1.subMapIndex[index - 1]
        }

        var colList = []
        for (var col = 0; col < 5; col++) {
          var colTmp = []
          for (var row = rows - 1; row >= 0; row--) {
            if (!subIndex.some(item => item == (row * 5 + col))) {
              colTmp.push(subMap[row * 5 + col])
            } else {
              if (data.gameId == 5002) {
                if(subMap[row * 5 + col].length >= 2) {
                  colTmp.push("W")
                }
              }
              if (data.gameId == 5003) {
                colTmp.push("0")
              }
            }
          }

          var colNew = data.detail.allRestocks[index + 1].restock[col].symbols
          if (colNew) {
            if (data.gameId == 5003)
            {
              for (var i = colNew.length - 1; i >= 0; i--)
              {
                for (var col0 = 0; col0 < 5; col0++) {
                  if (colTmp[col0] == "0")
                  {
                    colTmp.splice(col0, 1, colNew[i])
                    break
                  }
                }
              }
            }
            else
            {
              for (var i = 0; i < colNew.length; i++)
              {
                colTmp.push(colNew[i])
              }
            }
          }
          colList.push(colTmp)
        }
        if (data.gameId == 5003)
        {
            var colWWCopy = data.detail.springs[index + 1] ? data.detail.springs[index + 1].Positions : null
            if (colWWCopy && colWWCopy.length > 0) {
              for (var i = 0; i < colWWCopy.length; i++) {
                var x = colWWCopy[i].x ? colWWCopy[i].x : 0
                var y = colWWCopy[i].y ? colWWCopy[i].y : 0

                colList[x].splice(3 - y, 1, "WW")
              }
            }
        }

        // console.log(colList, "colList")
        // console.log(subMap, "subMap")

        subMap = []
        for (var j = rows - 1; j >= 0; j--)
        {
          for (var i = 0; i < 5; i++)
          {
            subMap.push(colList[i][j])
          }
        }
        // console.log(subMap, "subMap")
        var subIndexNew = []
        var detailList = []
        var geValueTmp = s.showSlotsWinLine(data.gameId, subMap, 0, rows).m_dict
        slots_tool.pushSubMapLine(this1.winlines,slots_tool.getSubLineHeadName(index),s.showSlotsWinLineInfo(data.gameId, subMap, 0, rows))
        //console.log(geValueTmp, "geValueTm[]")
        if (Object.keys(geValueTmp).length != 0) {
          for (var i = 0; i < Object.keys(geValueTmp).length; i++) {
            var mapIndexTmp = Object.values(geValueTmp)[i].flat(Infinity)

            for (var j = 0; j < mapIndexTmp.length; j++) {
              subIndexNew.push(mapIndexTmp[j])
            }

            var detail = {}
            var lines = 1;
            var mapIndexFullTmp = Object.values(geValueTmp)[i]
            for (var j = 0; j < mapIndexFullTmp.length; j++) {
              lines = lines * mapIndexFullTmp[j].length
            }

            detail.key = Object.keys(geValueTmp)[i]
            detail.lines = lines
            detail.length = Object.values(geValueTmp)[i].length
            if (odd_map !=null)
            {
              let mul_value = slots_tool.read_index_mul(mul_array,winIndex,data.isFree);
              detail = slots_tool.winInfo(odd_map,detail,mul_value);
            }
            winValueList.push(detail.winValue);
            detailList.push(detail)
          }
        }
        winIndex++;
        this1.subMapList.push(subMap)
        this1.subMapIndex.push(subIndexNew)
        this1.subMapListDetail.push(detailList)

      }
    }
    slots_tool.drawSlotLines(this1,this1.winlines)
    if (data.gameId == 5003)
    {
      this1.winValueTotal = slots_tool.TotalValue(winValueList,slots_tool.detailBet(data),1,slots_tool.isFree(data));
    }else{
      this1.winValueTotal = slots_tool.TotalValue(winValueList,slots_tool.detailBet(data),50,slots_tool.isFree(data));
    }

}

export {
  game_5000_to_5003
};



// WEBPACK FOOTER //
// ./src/components/slots/game_5000_to_5003.js